export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 23" fill="none">
            <path
                d="M117 1.48242C118.381 1.48242 119.5 2.60171 119.5 3.98242V19.9824C119.5 21.3631 118.381 22.4824 117 22.4824H9.05002C8.23479 22.4824 7.47078 22.0849 7.00286 21.4174L1.39524 13.4174C0.791458 12.556 0.791458 11.4088 1.39524 10.5475L7.00286 2.54746C7.47078 1.8799 8.23479 1.48242 9.05002 1.48242H117Z"
                stroke="#FF8000"
            />
            <path
                d="M117 1.48242C118.381 1.48242 119.5 2.60171 119.5 3.98242V19.9824C119.5 21.3631 118.381 22.4824 117 22.4824H9.05002C8.23479 22.4824 7.47078 22.0849 7.00286 21.4174L1.39524 13.4174C0.791458 12.556 0.791458 11.4088 1.39524 10.5475L7.00286 2.54746C7.47078 1.8799 8.23479 1.48242 9.05002 1.48242H117Z"
                stroke="url(#paint0_linear_48_2722)"
            />
            <defs>
                <linearGradient id="paint0_linear_48_2722" x1="1" y1="14.9824" x2="80.3515" y2="108.208" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0161916" stopColor="#FD720E" />
                    <stop offset="0.364526" stopColor="#FF910F" />
                    <stop offset="0.6434" stopColor="#FFB84F" />
                </linearGradient>
            </defs>
        </svg>
    );
}
